"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7361],{

/***/ 22319:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var deepstash_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40643);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var utils_global__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63069);







var FullWidthScrollableWrapper = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.forwardRef(function(_param, ref) {
    var children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        gridGap: utils_global__WEBPACK_IMPORTED_MODULE_3__/* .GAP_SIZE_REM */ .L3,
        justifyContent: "left",
        width: "100%",
        px: {
            base: utils_global__WEBPACK_IMPORTED_MODULE_3__/* .GAP_SIZE_REM */ .L3,
            md: "calc(50vw - 368px)",
            lg: "calc(50vw - 560px)"
        },
        overflowX: "scroll",
        alignItems: "flex-start",
        ref: ref,
        pb: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.M.px
    }, props), {
        children: children
    }));
});
/* harmony default export */ __webpack_exports__["Z"] = (FullWidthScrollableWrapper);


/***/ }),

/***/ 13318:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var deepstash_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40643);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var src_components_social_ProfileCard__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24839);
/* harmony import */ var utils_strings_commonStrings__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51599);
/* harmony import */ var _components_SubsectionHeader__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(17005);
/* harmony import */ var utils_global__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(63069);










var CuratorSection = function(_param) {
    var user = _param.user, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_param, [
        "user"
    ]);
    var colorMode = (0,deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.useColorMode)().colorMode;
    var isMobileView = (0,deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.useIsMobileView)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Box, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, props), {
        children: [
            isMobileView ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_SubsectionHeader__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                pb: utils_global__WEBPACK_IMPORTED_MODULE_6__/* .GAP_SIZE_REM */ .L3,
                children: utils_strings_commonStrings__WEBPACK_IMPORTED_MODULE_4__/* ["default"].metacontent.curatorSectionHeader */ .Z.metacontent.curatorSectionHeader
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.PrimaryText, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.typography.primaryTextFonts.large.bold), {
                color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].textSecondary,
                type: "bold",
                children: utils_strings_commonStrings__WEBPACK_IMPORTED_MODULE_4__/* ["default"].metacontent.curatorSectionHeader */ .Z.metacontent.curatorSectionHeader
            })),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_social_ProfileCard__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                user: user,
                size: "lg"
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (CuratorSection);


/***/ }),

/***/ 24839:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var deepstash_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40643);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var utils_global__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63069);
/* harmony import */ var _buttons_FollowUserButtonV2__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(81089);
/* harmony import */ var _cards_BaseCard__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(46039);
/* harmony import */ var _navigation_NextLink__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(50752);
/* harmony import */ var _ProfilePicture__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7877);











var ProfileCard = function(_param) {
    var user = _param.user, size = _param.size, withBackground = _param.withBackground, maxNoOfLinesBio = _param.maxNoOfLinesBio, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_param, [
        "user",
        "size",
        "withBackground",
        "maxNoOfLinesBio"
    ]);
    var colorMode = (0,deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.useColorMode)().colorMode;
    var _photo;
    var renderProfilePicture = function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_navigation_NextLink__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
            href: "/u/".concat(user.username),
            passHref: true,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Link, {
                _hover: undefined,
                _active: undefined,
                _focus: undefined,
                onClick: utils_global__WEBPACK_IMPORTED_MODULE_3__/* .onLinkClick */ .nt,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ProfilePicture__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    boxSize: "4rem",
                    photo: (_photo = user.photo) !== null && _photo !== void 0 ? _photo : "",
                    size: "xl",
                    altTag: user.username,
                    imageBlurhash: user.photo_blurhash,
                    p: "0",
                    pr: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.M.rem,
                    mb: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.S.rem
                })
            })
        });
    };
    var userInfo = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_navigation_NextLink__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        href: "/u/".concat(user.username),
        passHref: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Link, {
            _hover: undefined,
            _active: undefined,
            _focus: undefined,
            onClick: utils_global__WEBPACK_IMPORTED_MODULE_3__/* .onLinkClick */ .nt,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.PrimaryText, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({
                    color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].text
                }, deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.typography.primaryHeadingFonts.small.bold), {
                    children: user.firstName + " " + user.lastName
                })),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.PrimaryText, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({
                    mb: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.S.rem,
                    color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].text,
                    opacity: 0.4
                }, deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.typography.primaryTextFonts.small), {
                    children: "@" + user.username
                }))
            ]
        })
    });
    var userBio = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.PrimaryText, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({
        color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].textSecondary,
        noOfLines: maxNoOfLinesBio
    }, deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.typography.primaryTextFonts.small), {
        children: user.bio
    }));
    if (size === "lg") {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_cards_BaseCard__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({
            width: "100%",
            flexDirection: "column",
            bgColor: withBackground ? deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].surface : "unset",
            hasHoverEffect: !!withBackground,
            py: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.XS.rem
        }, props), {
            children: [
                renderProfilePicture(),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, {
                    justifyContent: "space-between",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, {
                            flexDirection: "column",
                            children: userInfo
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_buttons_FollowUserButtonV2__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            userId: user.id,
                            height: utils_global__WEBPACK_IMPORTED_MODULE_3__/* .SQUARE_WIDTH_REM */ .wY,
                            width: "8rem"
                        })
                    ]
                }),
                userBio
            ]
        }));
    } else {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_cards_BaseCard__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({
            width: "100%",
            bgColor: withBackground ? deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].surface : "unset",
            hasHoverEffect: !!withBackground
        }, props), {
            children: [
                renderProfilePicture(),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, {
                    flexDir: "column",
                    children: [
                        userInfo,
                        userBio
                    ]
                })
            ]
        }));
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (ProfileCard);


/***/ }),

/***/ 27361:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ source_SourcePage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/providers/collection/CollectionProvider.tsx + 1 modules
var CollectionProvider = __webpack_require__(67183);
// EXTERNAL MODULE: ./src/providers/source/SourceProvider.tsx + 1 modules
var SourceProvider = __webpack_require__(35396);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/layout/Layout.tsx + 6 modules
var Layout = __webpack_require__(28146);
// EXTERNAL MODULE: ./src/providers/hooks/useProfile.ts
var useProfile = __webpack_require__(2334);
// EXTERNAL MODULE: ./src/types/enums.ts
var enums = __webpack_require__(41390);
// EXTERNAL MODULE: ./src/utils/constants.tsx
var constants = __webpack_require__(14531);
// EXTERNAL MODULE: ./src/utils/global.ts
var global = __webpack_require__(63069);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/deepstash-ui/esm/index.js + 78 modules
var esm = __webpack_require__(40643);
// EXTERNAL MODULE: ./src/providers/hooks/useAuth.ts + 1 modules
var useAuth = __webpack_require__(79139);
// EXTERNAL MODULE: ./src/providers/hooks/useSource.ts
var useSource = __webpack_require__(93361);
// EXTERNAL MODULE: ./src/components/collection/CollectionCard.tsx
var CollectionCard = __webpack_require__(72426);
// EXTERNAL MODULE: ./src/components/layout/components/FullWidthScrollableWrapper.tsx
var FullWidthScrollableWrapper = __webpack_require__(22319);
// EXTERNAL MODULE: ./src/components/layout/components/FullWidthSectionWrapper.tsx
var FullWidthSectionWrapper = __webpack_require__(41140);
// EXTERNAL MODULE: ./src/components/layout/components/SectionTitle.tsx
var SectionTitle = __webpack_require__(57401);
// EXTERNAL MODULE: ./src/components/navigation/NextLink.tsx
var NextLink = __webpack_require__(50752);
// EXTERNAL MODULE: ./src/components/source/source-collapsed/SourceCollapsed.tsx + 2 modules
var SourceCollapsed = __webpack_require__(85611);
// EXTERNAL MODULE: ./src/types/index.ts
var types = __webpack_require__(3620);
// EXTERNAL MODULE: ./src/page-components/source/components/CollectionInHeader.tsx
var CollectionInHeader = __webpack_require__(84803);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_extends.mjs
var _extends = __webpack_require__(40872);
// EXTERNAL MODULE: ./src/components/metacontent/components/SubsectionHeader.tsx
var SubsectionHeader = __webpack_require__(17005);
// EXTERNAL MODULE: ./src/components/source/source-collapsed/SourceCollapsedLarge.tsx
var SourceCollapsedLarge = __webpack_require__(72982);
// EXTERNAL MODULE: ./src/components/source/source-collapsed/SourceCollapsedMedium.tsx
var SourceCollapsedMedium = __webpack_require__(66048);
// EXTERNAL MODULE: ./src/utils/normalizers/source.ts + 1 modules
var normalizers_source = __webpack_require__(27079);
// EXTERNAL MODULE: ./src/utils/strings/commonStrings.ts
var commonStrings = __webpack_require__(51599);
;// CONCATENATED MODULE: ./src/page-components/source/components/SimilarSourcesList.tsx















var SimilarSourcesList = function(_param) {
    var props = (0,_extends/* default */.Z)({}, _param);
    var ref, ref1, ref2;
    var isMobileView = (0,esm.useIsMobileView)();
    var ref3 = (0,useSource/* default */.Z)(), source = ref3.source, similarSources = ref3.similarSources, relatedPosts = ref3.relatedPosts;
    if (!(similarSources === null || similarSources === void 0 ? void 0 : similarSources.length) && !(relatedPosts === null || relatedPosts === void 0 ? void 0 : (ref = relatedPosts.similar_articles) === null || ref === void 0 ? void 0 : ref.length)) return null;
    var sectionTitle = source && source.sourceType === enums/* SourceType.BOOK */.PO.BOOK ? commonStrings/* default.metacontent.similarBooksSectionHeader */.Z.metacontent.similarBooksSectionHeader : commonStrings/* default.metacontent.similarSourcesSectionHeader */.Z.metacontent.similarSourcesSectionHeader;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        flexDir: "column",
        w: "100%"
    }, props), {
        children: [
            isMobileView ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SubsectionHeader/* default */.Z, {
                pt: {
                    base: global/* GAP_SIZE_REM */.L3,
                    md: global/* SECTION_GAP_REM */.hM
                },
                pb: global/* GAP_SIZE_REM */.L3,
                children: sectionTitle
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionTitle/* default */.Z, {
                pt: global/* SECTION_GAP_REM */.hM,
                pb: esm.spacing.toRem(48),
                title: sectionTitle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
                flexDir: {
                    base: "column",
                    md: "row"
                },
                w: "100%",
                position: "relative",
                gridGap: global/* GAP_SIZE_REM */.L3,
                pb: global/* GAP_SIZE_REM */.L3,
                children: [
                    !!(relatedPosts === null || relatedPosts === void 0 ? void 0 : (ref1 = relatedPosts.similar_articles) === null || ref1 === void 0 ? void 0 : ref1.length) && (relatedPosts === null || relatedPosts === void 0 ? void 0 : relatedPosts.similar_articles.map(function(post, index) {
                        return isMobileView ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SourceCollapsedLarge/* default */.Z, {
                            source: (0,normalizers_source/* normalizeSource */.Nr)(post),
                            headingSize: "h4"
                        }, "source-card-".concat(index)) : /*#__PURE__*/ (0,jsx_runtime.jsx)(SourceCollapsedMedium/* default */.Z, {
                            headingSize: "h4",
                            source: (0,normalizers_source/* normalizeSource */.Nr)(post)
                        }, "source-card-".concat(index));
                    })),
                    !(relatedPosts === null || relatedPosts === void 0 ? void 0 : (ref2 = relatedPosts.similar_articles) === null || ref2 === void 0 ? void 0 : ref2.length) && !!(similarSources === null || similarSources === void 0 ? void 0 : similarSources.length) && similarSources.map(function(source, index) {
                        return isMobileView ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SourceCollapsedLarge/* default */.Z, {
                            source: source,
                            headingSize: "h4"
                        }, "source-card-".concat(index)) : /*#__PURE__*/ (0,jsx_runtime.jsx)(SourceCollapsedMedium/* default */.Z, {
                            headingSize: "h4",
                            source: source
                        }, "source-card-".concat(index));
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var components_SimilarSourcesList = (SimilarSourcesList);

// EXTERNAL MODULE: ./src/page-components/source/components/SourceCardIdeas.tsx
var SourceCardIdeas = __webpack_require__(24027);
// EXTERNAL MODULE: ./src/components/cards/CuratorsNote.tsx
var CuratorsNote = __webpack_require__(53032);
// EXTERNAL MODULE: ./src/components/metacontent/sections/CuratorSection.tsx
var CuratorSection = __webpack_require__(13318);
// EXTERNAL MODULE: ./src/page-components/source/components/SourceCardVerticalProgress.tsx
var SourceCardVerticalProgress = __webpack_require__(65821);
;// CONCATENATED MODULE: ./src/page-components/source/components/SourceCardIdeasMetaContent.tsx















var EditSourceButton = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5652).then(__webpack_require__.bind(__webpack_require__, 55652));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(55652)
            ];
        }
    }
});
var SourceCardMetaContent = function() {
    var isDesktopView = (0,esm.useIsDesktopView)();
    var colorMode = (0,esm.useColorMode)().colorMode;
    var isLoggedIn = (0,useAuth/* default */.Z)().isLoggedIn;
    var profile = (0,useProfile/* default */.Z)().profile;
    var source = (0,useSource/* default */.Z)().source;
    var sourceHref = react.useMemo(function() {
        var ref, ref1, ref2;
        return (source === null || source === void 0 ? void 0 : (ref = source.seo) === null || ref === void 0 ? void 0 : ref.source) ? "/book/".concat((ref1 = source.seo) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.source) === null || ref2 === void 0 ? void 0 : ref2.id, "/").concat((0,global/* slugify */.lV)(source.seo.source.title)) : "";
    }, [
        source
    ]);
    if (!source) return null;
    var dividerLine = /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Flex, {
        height: 2,
        bgColor: esm.color[colorMode].underground,
        width: "100%"
    });
    var renderLinkToBookSource = function() {
        if (source.sourceType === enums/* SourceType.BOOK */.PO.BOOK && source.seo !== undefined && source.seo !== null && source.seo.source !== undefined && source.seo.source !== null) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    dividerLine,
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Text, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, esm.typography.primaryTextFonts.large.regular), {
                        color: esm.color[colorMode].textSecondary,
                        children: [
                            "Curious about different takes? Check out our  ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: sourceHref,
                                style: {
                                    // textDecoration: 'none',
                                    color: esm.color[colorMode].textSecondary,
                                    fontWeight: "bold"
                                },
                                children: "".concat(source.title, " Summary")
                            }),
                            " book page to explore multiple unique summaries written by Deepstash users."
                        ]
                    }))
                ]
            });
        }
        return null;
    };
    var curatorData = /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
        w: {
            base: "100%",
            md: (0,global/* getRemWidthFromColumns */._P)(4)
        },
        flexDirection: "column",
        gridGap: global/* GAP_SIZE_REM */.L3,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CuratorSection/* default */.Z, {
                user: source.userData
            }),
            source.context && /*#__PURE__*/ (0,jsx_runtime.jsx)(CuratorsNote/* default */.Z, {
                text: source.context,
                quoteColor: (0,global/* getTintHex */.As)({
                    ogColor: source.imageColor,
                    opacity: 0.5,
                    colorScheme: colorMode
                }),
                showLabel: true
            }),
            isLoggedIn && ((profile === null || profile === void 0 ? void 0 : profile.id) === source.userData.id || (profile === null || profile === void 0 ? void 0 : profile.id) === constants/* VLADIMIR_USER_ID */.un) && /*#__PURE__*/ (0,jsx_runtime.jsx)(EditSourceButton, {}),
            renderLinkToBookSource()
        ]
    });
    return isDesktopView ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
        w: (0,global/* getRemWidthFromColumns */._P)(11),
        justifyContent: "space-between",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SourceCardVerticalProgress/* default */.Z, {
                source: source
            }),
            curatorData
        ]
    }) : curatorData;
};
/* harmony default export */ var SourceCardIdeasMetaContent = (SourceCardMetaContent);

// EXTERNAL MODULE: ./src/page-components/source/components/SourceSplashscreenBackground.tsx
var SourceSplashscreenBackground = __webpack_require__(1206);
// EXTERNAL MODULE: ./src/utils/strings/pageStrings.ts
var pageStrings = __webpack_require__(23244);
;// CONCATENATED MODULE: ./src/page-components/source/components/OtherTakesList.tsx















var OtherTakesList = function(_param) {
    var props = (0,_extends/* default */.Z)({}, _param);
    var isMobileView = (0,esm.useIsMobileView)();
    var colorMode = (0,esm.useColorMode)().colorMode;
    var ref = (0,useSource/* default */.Z)(), source = ref.source, relatedPosts = ref.relatedPosts;
    var sourceHref = react.useMemo(function() {
        var ref, ref1, ref2;
        return (source === null || source === void 0 ? void 0 : (ref = source.seo) === null || ref === void 0 ? void 0 : ref.source) ? "/book/".concat((ref1 = source.seo) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.source) === null || ref2 === void 0 ? void 0 : ref2.id, "/").concat((0,global/* slugify */.lV)(source.seo.source.title)) : "";
    }, [
        source
    ]);
    if (!(relatedPosts === null || relatedPosts === void 0 ? void 0 : relatedPosts.same_source_articles) || relatedPosts.same_source_articles.length === 0 || !source) return null;
    var sectionTitle = commonStrings/* default.metacontent.differentPerspectives */.Z.metacontent.differentPerspectives + " " + (source === null || source === void 0 ? void 0 : source.title);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        flexDir: "column",
        w: "100%"
    }, props), {
        children: [
            isMobileView ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SubsectionHeader/* default */.Z, {
                pt: {
                    base: global/* GAP_SIZE_REM */.L3,
                    md: global/* SECTION_GAP_REM */.hM
                },
                mb: esm.spacing.toRem(16),
                height: "auto",
                children: sectionTitle
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionTitle/* default */.Z, {
                pt: global/* SECTION_GAP_REM */.hM,
                pb: esm.spacing.toRem(16),
                title: sectionTitle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.PrimaryText, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, esm.typography.primaryTextFonts.medium.regular), {
                color: esm.color[colorMode].textSecondary,
                mb: esm.spacing.M.rem,
                children: pageStrings/* default.article.otherTakesDescription */.Z.article.otherTakesDescription
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Link, {
                href: sourceHref,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.PrimaryButton, {
                    mb: {
                        base: esm.spacing.toRem(16),
                        md: global/* GAP_SIZE_REM */.L3
                    },
                    h: esm.spacing.toRem(48),
                    textAlign: "center",
                    children: [
                        source.title,
                        " Summary"
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Flex, {
                flexDir: {
                    base: "column",
                    md: "row"
                },
                w: "100%",
                position: "relative",
                gridGap: global/* GAP_SIZE_REM */.L3,
                pb: global/* GAP_SIZE_REM */.L3,
                children: relatedPosts.same_source_articles.map(function(post, index) {
                    var ref, ref1, ref2, ref3;
                    return isMobileView ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SourceCollapsedLarge/* default */.Z, {
                        source: (0,normalizers_source/* normalizeSource */.Nr)(post),
                        headingSize: "h4",
                        titleOverride: "".concat(((ref = post.user_data) === null || ref === void 0 ? void 0 : ref.first_name) + " " + ((ref1 = post.user_data) === null || ref1 === void 0 ? void 0 : ref1.last_name), "'s Key Ideas from ").concat(post.title)
                    }, "source-card-".concat(index)) : /*#__PURE__*/ (0,jsx_runtime.jsx)(SourceCollapsedMedium/* default */.Z, {
                        headingSize: "h4",
                        source: (0,normalizers_source/* normalizeSource */.Nr)(post),
                        titleOverride: "".concat(((ref2 = post.user_data) === null || ref2 === void 0 ? void 0 : ref2.first_name) + " " + ((ref3 = post.user_data) === null || ref3 === void 0 ? void 0 : ref3.last_name), "'s Key Ideas from ").concat(post.title)
                    }, "source-card-".concat(index));
                })
            })
        ]
    }));
};
/* harmony default export */ var components_OtherTakesList = (OtherTakesList);

// EXTERNAL MODULE: ./src/utils/metatopics.constants.ts
var metatopics_constants = __webpack_require__(90031);
;// CONCATENATED MODULE: ./src/page-components/source/components/SourceCard.tsx
























// eslint-disable-next-line react/display-name
var SourceCard = function(param) {
    var pageMetadata = param.pageMetadata, sectionBefore = param.sectionBefore;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15;
    var source = (0,useSource/* default */.Z)().source;
    var router = (0,next_router.useRouter)();
    var colorMode = (0,esm.useColorMode)().colorMode;
    var isLoggedIn = (0,useAuth/* default */.Z)().isLoggedIn;
    var renderAuthorsSection = function() {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6;
        if (source === undefined || source.sourceType !== types/* SourceType.BOOK */.PO.BOOK || ((ref = source.seo) === null || ref === void 0 ? void 0 : (ref1 = ref.source) === null || ref1 === void 0 ? void 0 : ref1.publishers) === undefined || ((ref2 = source.seo) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.source) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.publishers) === null || ref4 === void 0 ? void 0 : ref4.length) === 0) {
            return null;
        }
        var publishersTotal = (ref5 = source.seo) === null || ref5 === void 0 ? void 0 : ref5.source.publishers.length;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
            flexDirection: "row",
            mt: "0.5rem",
            gridColumnGap: 8,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.PrimaryText, {
                    type: "regular",
                    color: esm.color[colorMode].textSecondary,
                    size: "l",
                    children: "by"
                }),
                (ref6 = source.seo) === null || ref6 === void 0 ? void 0 : ref6.source.publishers.map(function(publisher, index) {
                    var publisherSlug = (0,global/* slugify */.lV)(publisher.name);
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                        href: "/book/author/".concat(publisher.id, "/").concat(publisherSlug),
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Link, {
                            _focus: undefined,
                            _hover: undefined,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.PrimaryText, {
                                type: "semiBold",
                                color: esm.color[colorMode].text,
                                size: "l",
                                children: [
                                    publisher.name,
                                    publishersTotal > 1 && index < publishersTotal - 1 && ","
                                ]
                            })
                        })
                    }, "publisher-".concat(index));
                })
            ]
        });
    };
    var authorsSectionComponent = react.useMemo(function() {
        return renderAuthorsSection();
    }, [
        source
    ]);
    if (!source) return null;
    var sourceTitleSection = {
        content: /*#__PURE__*/ (0,jsx_runtime.jsx)(FullWidthSectionWrapper/* default */.Z, {
            containerProps: {
                flexDirection: "column"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SourceCollapsed/* default */.Z, {
                showTopics: true,
                size: "full",
                py: global/* GAP_SIZE_REM */.L3,
                preload: true,
                headingSize: "h1",
                overrideAuthorComponent: authorsSectionComponent !== null && authorsSectionComponent !== void 0 ? authorsSectionComponent : undefined,
                shouldHideCta: true
            })
        }),
        sectionStyle: {
            marginBottom: global/* GAP_SIZE_REM */.L3
        },
        isFullscreen: true
    };
    var sourceIdeasSection = {
        content: /*#__PURE__*/ (0,jsx_runtime.jsx)(SourceCardIdeas/* default */.Z, {
            isNsiBlocked: !router.query.show
        }),
        metaContent: /*#__PURE__*/ (0,jsx_runtime.jsx)(SourceCardIdeasMetaContent, {}),
        metaContentTopOffset: 0,
        metaContentStickyOffset: global/* GAP_SIZE */.DG * 2,
        metaContentColumnStart: 0
    };
    var ref16;
    var recommendedCollectionsSection = {
        content: !isLoggedIn && !!((ref = source.seo) === null || ref === void 0 ? void 0 : ref.similar_collections) && source.seo.similar_collections.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                !!((ref1 = source.seo) === null || ref1 === void 0 ? void 0 : ref1.recommended_collection) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(FullWidthSectionWrapper/* default */.Z, {
                    containerProps: {
                        flexDirection: "column",
                        gridGap: esm.spacing.M.rem
                    },
                    marginTop: global/* GAP_SIZE_REM */.L3,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.PrimaryHeading, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                            size: "h3"
                        }, esm.typography.primaryHeadingFonts.small.bold), {
                            color: esm.color[colorMode].text,
                            children: [
                                (source === null || source === void 0 ? void 0 : (ref2 = source.userData) === null || ref2 === void 0 ? void 0 : ref2.firstName) + " " + (source === null || source === void 0 ? void 0 : (ref3 = source.userData) === null || ref3 === void 0 ? void 0 : ref3.lastName) + "'s",
                                " ",
                                "ideas are part of this journey:"
                            ]
                        })),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionInHeader/* default */.Z, {
                            collection: source.seo.recommended_collection,
                            topic: (ref16 = (ref4 = source.ideas[0].hashtags) === null || ref4 === void 0 ? void 0 : ref4[0]) !== null && ref16 !== void 0 ? ref16 : ""
                        })
                    ]
                }) : null,
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FullWidthSectionWrapper/* default */.Z, {
                    marginTop: {
                        base: global/* GAP_SIZE_REM */.L3,
                        md: global/* SECTION_GAP_REM */.hM
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionTitle/* default */.Z, {
                        title: "Related collections"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FullWidthScrollableWrapper/* default */.Z, {
                    mt: 32,
                    children: (ref5 = source.seo) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.similar_collections) === null || ref6 === void 0 ? void 0 : ref6.slice(0, 4).map(function(collection, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionCard/* default */.Z, {
                            collection: collection
                        }, "collection-".concat(index));
                    })
                })
            ]
        }) : null,
        isFullscreen: true
    };
    var similarSourcesSection = {
        content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FullWidthSectionWrapper/* default */.Z, {
            mt: {
                base: global/* GAP_SIZE_REM */.L3,
                md: global/* SECTION_GAP_REM */.hM
            },
            containerProps: {
                flexDirection: "column"
            },
            children: [
                source.sourceType === types/* SourceType.BOOK */.PO.BOOK && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_OtherTakesList, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SimilarSourcesList, {})
            ]
        }),
        isFullscreen: true
    };
    var ref17;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SourceSplashscreenBackground/* default */.Z, {
                zIndex: -1,
                themeColor: source.imageColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* default */.Z, {
                pageMetadata: pageMetadata,
                sections: sectionBefore ? [
                    sectionBefore,
                    sourceTitleSection,
                    sourceIdeasSection,
                    recommendedCollectionsSection,
                    similarSourcesSection, 
                ] : [
                    sourceTitleSection,
                    sourceIdeasSection,
                    recommendedCollectionsSection,
                    similarSourcesSection, 
                ],
                isShortProAd: true,
                showFooterPrices: false,
                breadcrumbs: !!((ref7 = source.ideas[0]) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.hashtags) === null || ref8 === void 0 ? void 0 : ref8.length) ? [
                    {
                        title: "Home",
                        link: "/"
                    },
                    {
                        title: (ref17 = (ref11 = metatopics_constants/* UNSORTED_TOPICS */.Ay[(ref9 = source.ideas[0]) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.hashtags) === null || ref10 === void 0 ? void 0 : ref10[0]]) === null || ref11 === void 0 ? void 0 : ref11.title) !== null && ref17 !== void 0 ? ref17 : (ref12 = source.ideas[0]) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.hashtags) === null || ref13 === void 0 ? void 0 : ref13[0],
                        link: "/topic/" + ((ref14 = source.ideas[0]) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.hashtags) === null || ref15 === void 0 ? void 0 : ref15[0])
                    },
                    {
                        title: source.title,
                        link: "/article/".concat(source.id, "/").concat((0,global/* slugify */.lV)(source.title))
                    }, 
                ] : undefined
            })
        ]
    });
};
/* harmony default export */ var components_SourceCard = (SourceCard);

;// CONCATENATED MODULE: ./src/page-components/source/SourcePage.tsx












var EmptySourcePage = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1381).then(__webpack_require__.bind(__webpack_require__, 21381));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(21381)
            ];
        }
    }
});
var PrivateSourcePage = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1847).then(__webpack_require__.bind(__webpack_require__, 41847));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(41847)
            ];
        }
    }
});
var DraftProvider = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 57825));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(57825)
            ];
        }
    }
});
var SourceCardEditor = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(6482), __webpack_require__.e(630), __webpack_require__.e(5522), __webpack_require__.e(9574), __webpack_require__.e(7510), __webpack_require__.e(1335), __webpack_require__.e(9215)]).then(__webpack_require__.bind(__webpack_require__, 98171));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(98171)
            ];
        }
    },
    ssr: false
});
var SourcePage = function(param) {
    var source = param.source, collection = param.collection, similarSources = param.similarSources, startInEditMode = param.startInEditMode, pageMetadata = param.pageMetadata, sectionBefore = param.sectionBefore, isInitialLoggedIn = param.isInitialLoggedIn, relatedPosts = param.relatedPosts;
    var profile = (0,useProfile/* default */.Z)().profile;
    var isOwnArticle = (profile === null || profile === void 0 ? void 0 : profile.id) === source.userData.id || (profile === null || profile === void 0 ? void 0 : profile.id) === constants/* VLADIMIR_USER_ID */.un;
    var isDraft = source.status === enums/* ArticleStatus.DRAFT */.af.DRAFT;
    var ref = (0,react.useState)(startInEditMode), editMode = ref[0], setEditMode = ref[1];
    var router = (0,next_router.useRouter)();
    (0,react.useEffect)(function() {
        if (router.query.edit) {
            if (isOwnArticle) {
                setEditMode(true);
            } else {
                (0,global/* clearUrlParams */.Jr)({
                    params: [
                        "edit"
                    ],
                    router: router,
                    forceRefresh: true
                });
                setEditMode(false);
            }
        } else if (editMode) {
            setEditMode(false);
        }
    }, [
        router.query.edit
    ]);
    if ((0,global/* isSourceEmpty */.dq)(source) && !isDraft) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptySourcePage, {});
    } else if (isDraft && !isOwnArticle) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* default */.Z, {
            pageMetadata: pageMetadata,
            sections: [
                {
                    content: /*#__PURE__*/ (0,jsx_runtime.jsx)(PrivateSourcePage, {})
                }
            ]
        });
    }
    if (isOwnArticle && editMode) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(DraftProvider, {
            draft: source,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SourceCardEditor, {
                pageMetadata: pageMetadata
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionProvider/* default */.Z, {
        collection: collection,
        isInitialRequestLoggedIn: isInitialLoggedIn,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SourceProvider/* default */.Z, {
            source: source,
            similarSources: similarSources,
            relatedPosts: relatedPosts,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SourceCard, {
                pageMetadata: pageMetadata,
                sectionBefore: sectionBefore
            })
        })
    });
};
/* harmony default export */ var source_SourcePage = (SourcePage);


/***/ }),

/***/ 84803:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var deepstash_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40643);
/* harmony import */ var utils_global__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63069);
/* harmony import */ var src_components_image_NextImage__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(91260);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var src_components_navigation_NextLink__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(50752);








 // Use it instead of own useRouter for fixing scroll problems

var COLLECTION_IMAGE_SIZE = {
    WIDTH: 140,
    HEIGHT: 175,
    BORDER_RADIUS: 8
};
var FALLBACK_SKILLS = [
    "How to prioritize tasks effectively",
    "How to minimize distractions",
    "How to optimize your work environment",
    "How to use technology to your advantage",
    "How to delegate tasks efficiently", 
];
var CollectionInHeader = function(_param) {
    var collection = _param.collection, topic = _param.topic, _showStartJourneyButton = _param.showStartJourneyButton, showStartJourneyButton = _showStartJourneyButton === void 0 ? false : _showStartJourneyButton, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_param, [
        "collection",
        "topic",
        "showStartJourneyButton"
    ]);
    var isMobileView = (0,deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.useIsMobileView)();
    var colorMode = (0,deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.useColorMode)().colorMode;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    var collectionSlug = react__WEBPACK_IMPORTED_MODULE_1__.useMemo(function() {
        return (0,utils_global__WEBPACK_IMPORTED_MODULE_3__/* .slugify */ .lV)(collection.name);
    }, [
        collection.name
    ]);
    var collectionPageRoute = "/collection/".concat(collection.id, "/").concat(collectionSlug);
    var finalSkills = react__WEBPACK_IMPORTED_MODULE_1__.useMemo(function() {
        return collection.skills !== undefined ? collection.skills : FALLBACK_SKILLS;
    }, [
        collection.skills
    ]);
    var renderSkill = function(param) {
        var skill = param.skill, index = param.index;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.Flex, {
            flexDirection: "row",
            alignItems: "flex-start",
            gridColumnGap: 4,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.CheckFillSvg, {
                    color: "green",
                    boxSize: isMobileView ? "24px" : "26px"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.Text, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, isMobileView ? deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.typography.primaryTextFonts.large.regular : deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.typography.primaryTextFonts.large.regular), {
                    color: deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.color[colorMode].textSecondary,
                    flex: 1,
                    children: skill
                }))
            ]
        }, "skill-".concat(index));
    };
    var collectionImage = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_image_NextImage__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        wrapperStyle: {
            width: COLLECTION_IMAGE_SIZE.WIDTH,
            height: COLLECTION_IMAGE_SIZE.HEIGHT,
            borderRadius: COLLECTION_IMAGE_SIZE.BORDER_RADIUS,
            cursor: "pointer"
        },
        imageUrl: collection.image,
        blurhash: collection.image_blurhash,
        alt: "".concat(collection.name),
        priority: false,
        onClick: function() {
            router.push(collectionPageRoute);
        }
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.Flex, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
        bgColor: "".concat(deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.color[colorMode].top, "66"),
        flexDirection: isMobileView ? "column" : "row",
        p: utils_global__WEBPACK_IMPORTED_MODULE_3__/* .GAP_SIZE */ .DG,
        gridGap: utils_global__WEBPACK_IMPORTED_MODULE_3__/* .GAP_SIZE */ .DG,
        borderRadius: 16,
        alignItems: "flex-end"
    }, props), {
        children: [
            isMobileView ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.Flex, {
                width: "100%",
                justifyContent: "center",
                children: collectionImage
            }) : collectionImage,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.Flex, {
                flex: 1,
                flexDirection: "column",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.Text, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.typography.primaryTextFonts.large.regular), {
                        color: deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.color[colorMode].text,
                        children: "Learn more about ".concat(topic, " with this collection")
                    })),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_navigation_NextLink__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        href: collectionPageRoute,
                        passHref: true,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.Link, {
                            _focus: undefined,
                            _hover: {
                                textDecoration: "underline"
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.Text, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.typography.primaryHeadingFonts.medium.bold), {
                                color: deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.color[colorMode].text,
                                children: collection.name
                            }))
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.Flex, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
                        flexDirection: "column",
                        gridRowGap: 8,
                        mt: 16
                    }, isMobileView ? {
                        width: "100%"
                    } : {}), {
                        children: finalSkills.slice(0, 3).map(function(skill, index) {
                            return renderSkill({
                                skill: skill,
                                index: index
                            });
                        })
                    }))
                ]
            }),
            showStartJourneyButton && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.PrimaryButton, {
                backgroundColor: deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.color[colorMode].text,
                height: deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.spacing.toRem(48),
                width: {
                    base: "100%",
                    md: "auto"
                },
                onClick: function() {
                    return router.push(collectionPageRoute);
                },
                children: "Start Journey"
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (CollectionInHeader);


/***/ }),

/***/ 65821:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var deepstash_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40643);
/* harmony import */ var providers_hooks_useActivity__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8565);
/* harmony import */ var providers_hooks_useAuth__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79139);
/* harmony import */ var providers_hooks_useNsiActivity__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7964);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67294);
/* harmony import */ var utils_global__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(63069);







var SourceCardVerticalProgress = function(param) {
    var source = param.source;
    var isLoggedIn = (0,providers_hooks_useAuth__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)().isLoggedIn;
    var activity = (0,providers_hooks_useActivity__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)().activity;
    var ref = (0,providers_hooks_useNsiActivity__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(), nsiReads = ref.reads;
    var colorMode = (0,deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.useColorMode)().colorMode;
    var isIdeaRead = function(ideaId) {
        var ref;
        return (activity === null || activity === void 0 ? void 0 : (ref = activity.reads) === null || ref === void 0 ? void 0 : ref[ideaId]) || nsiReads.sessionReads.has(ideaId);
    };
    if (!source) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, {
        w: (0,utils_global__WEBPACK_IMPORTED_MODULE_6__/* .getRemWidthFromColumns */ ._P)(1),
        gridGap: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.XS.rem,
        flexDirection: "column",
        mt: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.XS.rem,
        children: (isLoggedIn ? source.ideas : source.ideas.slice(0, 4)).map(function(idea, index) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Box, {
                w: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.toRem(4),
                h: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.toRem(200 / (isLoggedIn ? source.ideas : source.ideas.slice(0, 4)).length),
                borderRadius: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.toRem(2),
                backgroundColor: isIdeaRead(idea.id) ? deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color.success : deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].textDisabled,
                transition: "all 0.6s cubic-bezier(.43,.22,.05,.99)",
                opacity: isIdeaRead(idea.id) ? 0.8 : 0.4
            }, index);
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SourceCardVerticalProgress);


/***/ }),

/***/ 1206:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var deepstash_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40643);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14531);
/* harmony import */ var utils_global__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(63069);








var SourceSplashscreenBackground = function(_param) {
    var themeColor = _param.themeColor, customGradient = _param.customGradient, customHeight = _param.customHeight, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "themeColor",
        "customGradient",
        "customHeight"
    ]);
    var colorMode = (0,deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.useColorMode)().colorMode;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Box, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        position: "absolute",
        height: customHeight !== null && customHeight !== void 0 ? customHeight : "100vh",
        width: "100%",
        top: 0,
        left: 0,
        overflow: "hidden"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Box, {
                position: "absolute",
                height: "100%",
                width: "100%",
                top: 0,
                left: 0,
                background: customGradient !== null && customGradient !== void 0 ? customGradient : (0,utils_constants__WEBPACK_IMPORTED_MODULE_3__/* .createGradient */ .FK)((0,utils_global__WEBPACK_IMPORTED_MODULE_4__/* .getTintHex */ .As)({
                    ogColor: themeColor !== null && themeColor !== void 0 ? themeColor : "",
                    opacity: 0.7,
                    colorScheme: colorMode
                }), 90)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Box, {
                position: "absolute",
                height: "100%",
                width: "100%",
                top: 0,
                left: 0,
                background: (0,utils_constants__WEBPACK_IMPORTED_MODULE_3__/* .createGradient */ .FK)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].background, 270)
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (SourceSplashscreenBackground);


/***/ })

}]);